import type { ReactNode } from 'react';
import { ChevronRight } from 'lucide-react';
import './help.css';

/** Where a row goes: a press, or a link (the developer docs beside the app, the support address). */
export type HelpAction = { press: () => void } | { href: string; external?: boolean };

/** One way to help: an icon, the thing in two words, one line, and where it goes. */
export interface HelpRowProps {
  icon: ReactNode;
  title: string;
  line: string;
  action: HelpAction;
}

/** A row of Help: a button, or a link when it goes somewhere of its own. */
export function HelpRow({ icon, title, line, action }: HelpRowProps): ReactNode {
  const body = (
    <>
      <span className="help-row__icon" aria-hidden="true">
        {icon}
      </span>
      <span className="help-row__words">
        <strong>{title}</strong>
        <span>{line}</span>
      </span>
      <ChevronRight className="help-row__go" size={16} aria-hidden="true" />
    </>
  );
  if ('href' in action)
    return (
      <a
        className="help-row"
        href={action.href}
        {...(action.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      >
        {body}
      </a>
    );
  return (
    <button type="button" className="help-row" onClick={action.press}>
      {body}
    </button>
  );
}
